import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ElementOverflowListenerModule } from '®shared/element-overflow-listener';

import { CitationSwitcherMenuComponent } from './citation-switcher-menu.component';

@NgModule({
  imports: [
    BsDropdownModule,
    CommonModule,
    ElementOverflowListenerModule,
    TooltipModule,
  ],
  declarations: [CitationSwitcherMenuComponent],
  exports: [CitationSwitcherMenuComponent],
})
export class CitationSwitcherModule {}
